const API_URLS = {
  baseUrl: '',

  // // Staging
  // getCatalogue: 'https://eu2-stagingref.api.vodafone.com/digitalProductRecommendation/v1/digitalProductRecommendation',
  // activateOffer: 'https://eu2-stagingref.api.vodafone.com/tmf-api/productOrderingManagement/v4/productOrder',

  // Live
  getCatalogue: 'https://eu2.api.vodafone.com/digitalProductRecommendation/v1/digitalProductRecommendation',
  activateOffer: 'https://eu2.api.vodafone.com/tmf-api/productOrderingManagement/v4/productOrder',
}

const COMMON_HEADERS = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
}

export { API_URLS, COMMON_HEADERS }
